import { CrudForm } from '../../containers/crud/crudForm';
import { translate } from '../../../localization';
import { Crud } from '../../containers/crud/crud';
import { formatDate } from '@arivaa-react/helpers/date-util';
import { Switch } from 'antd';
import { UpdateEntity } from '../../containers/updateEntity';
import { useCrudData } from '../../containers/crud/crudContext';
import { WebCrud } from '../../containers/crud/webCrud';
export default function Technologies() {
  const { refresh } = useCrudData();
  return (
    <WebCrud
      api="technology"
      FormComponent={(props) => (
        <CrudForm
          {...props}
          elements={[
            {
              type: 'file',
              name: 'image',
              label: translate('technology.image'),
              required: true,
              fileCode: 'mediaFile',
            },
            {
              type: 'text',
              name: 'title',
              label: translate('technology.title'),
              required: true,
              inputProps: {
                maxLength: 200,
              },
            },
            {
              type: 'switch',
              name: 'published',
              label: translate('technology.published'),
              required: false,
            },
          ]}
        />
      )}
    >
      <Crud.Header title="Technologies">
        <Crud.Header.Actions.Common />
      </Crud.Header>
      <Crud.Table
        actions={[
          ...Crud.Table.RowActions.Common,
          () => (
            <Crud.Table.RowActions.DuplicateRecordWithForm
              elements={[
                {
                  type: 'text',
                  label: 'Enter new title',
                  name: 'title',
                  inputProps: {
                    placeholder: 'title',
                  },
                },
              ]}
            />
          ),
        ]}
        columns={[
          {
            title: translate('common.title'),
            dataIndex: 'title',
          },
          {
            title: translate('technology.published'),
            dataIndex: 'published',
            render: (value, record) => {
              return (
                <UpdateEntity
                  record={record}
                  getChildren={({ loading, updateEntity }) => {
                    return (
                      <Switch
                        loading={loading}
                        checked={record.published}
                        onChange={async (checked) => {
                          await updateEntity({ published: checked });
                          refresh();
                        }}
                      />
                    );
                  }}
                />
              );
            },
          },
          {
            title: translate('technology.publishedAt'),
            dataIndex: 'createdAt',
            render: (text) => {
              return formatDate(text);
            },
          },
        ]}
      >
        <Crud.Table.Header>
          <Crud.Search
            fields={[
              {
                name: 'title',
                type: 'text',
                inputProps: {
                  placeholder: translate('common.title'),
                },
              },
              {
                label: translate('technology.published'),
                name: 'published',
                type: 'custom',
                Component: Switch,
              },
            ]}
          ></Crud.Search>
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
        <Crud.Table.TableActions.Common />
      </Crud.Table>
    </WebCrud>
  );
}
